/* eslint-disable */
export const aura = [
	{
    info: '10 Aura Tokens',
    name: 'Current Balance',
  },
	{
    info: '10 Aura Tokens',
    name: 'Unvested Balance',
  },
	{
    info: '10/12/22',
    name: 'Next Vesting Date',
    redirectUrl: 'link'
  },
	{
    info: '10 Aura Tokens',
    name: 'Next Vest',
  },
];

export const staking = [
  {
    info: '10 Aura Tokens',
    name: 'Current Balance',
  },
  {
    info: '10 Aura Tokens',
    name: 'Current Balance',
    redirectUrl: 'link'
  },
  {
    info: '10 Aura Tokens',
    name: 'Current Balance',
    redirectUrl: 'link'
  },
];

export const govern = [
  {
    info: '10 Aura Tokens',
    name: 'Current Balance',
  },
];

export const fuseblocks = [
  {
    info: '10 Aura Tokens',
    name: 'Current Balance',
    redirectUrl: 'link'
  },
  {
    info: '10 Aura Tokens',
    name: 'Current Balance',
    redirectUrl: 'link'
  },
];

export const auraMenu = [
  {
    category: 'aura',
    path: 'aura',
    items: aura,
    icon: 'aura_icon',
    name: 'Aura',
  },
  {
    category: 'staking',
    path: 'staking',
    items: staking,
    icon: 'staking_icon',
    name: 'Staking',
  },
  {
    category: 'govern',
    path: 'govern',
    items: govern,
    icon: 'governance_icon',
    name: 'Govern',
  },
]
